export const stagingServer = 'https://api.dev.node.pms.skunktest.work/api';
export const PreProdServer = 'http://localhost:3001/api';
export const ProdServer = 'https://api.prod.node.pms.skunktest.work/api';
